import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TRUST_PORTAL_URL, POWERED_BY_TEXT } from "../data/siteContent";
import SpinningShield from "./SpinningShield";

const Header = ({ light = false }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // On light-background pages (About, Privacy, Terms, Contact) the header
  // stays transparent until scrolled, so cream text would sit directly on
  // a cream page background -- switch the wordmark to dark ink in that case.
  const wordmarkColor = light && !scrolled ? "text-ink" : "text-cream";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ink/90 backdrop-blur-md border-b border-white/8 py-3"
          : "bg-transparent py-5"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <div className="flex flex-col">
          <Link to="/" className="flex items-center gap-3 group">
            <SpinningShield
              size={46}
              opacity={0.95}
              duration={18}
              className="drop-shadow-[0_0_10px_rgba(201,162,60,0.35)]"
            />
            <span
              className={`font-display text-lg sm:text-xl tracking-[0.12em] transition-colors duration-500 ${wordmarkColor}`}
            >
              IRON GATE <span className="text-gold">CONSULTING</span>
            </span>
          </Link>
          <span
            className="text-gold text-[10px] sm:text-xs mt-1 ml-[58px] tracking-wide"
            data-testid="powered-by-top"
          >
            {POWERED_BY_TEXT}
          </span>
        </div>
        <a
          href={TRUST_PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-get-started-btn"
          className="group inline-flex items-center gap-2 bg-gold text-ink font-bold tracking-[0.08em] uppercase text-xs sm:text-sm px-5 sm:px-6 py-2.5 sm:py-3 rounded-full hover:bg-goldlight transition-colors duration-300"
        >
          Get Started
          <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </div>
    </header>
  );
};

export default Header;
